import * as React from 'react';
import clsx from 'clsx';
import { CypressI } from 'interfaces/cypress';
import Image from 'next/image';

interface SpinnerProps {
	type?: 'loadingPage';
	width?: string;
	height?: string;
	className?: string;
}

export const Spinner: React.FC<SpinnerProps & CypressI> = ({
	dataCY,
	type,
	width = type === 'loadingPage' ? 'w-10' : 'w-6',
	className,
}) => {
	return (
		<div
			data-cy={dataCY}
			className={clsx('flex items-center justify-center', width, className)}
		>
			<div role="status text-center">
				<Image
					src={'/img/common/spinner.png'}
					alt="spinner"
					width={50}
					height={50}
					className="animate-spin"
					quality={75}
					priority
				/>
				<span className="sr-only">Loading...</span>
			</div>
		</div>
	);
};
